import { FormattedMessage } from 'react-intl'
import { Intro } from '../../shared/Intro'
import { useSelector } from 'react-redux'
import {
  selectCustomerEmail,
  selectCustomerNMLS,
  selectCustomerPhone,
  selectCustomerPhotoUri,
  selectCustomerTitle,
  selectName
} from '../../../store/selectors/customerProfile'
import { selectClientFirstName } from '../../../store/selectors/client'

export const HomeownerIntro = () => {
  const customerName = useSelector(selectName)
  const email = useSelector(selectCustomerEmail)
  const photoUri = useSelector(selectCustomerPhotoUri)
  const nmls = useSelector(selectCustomerNMLS)
  const toName = useSelector(selectClientFirstName)
  const phone = useSelector(selectCustomerPhone)
  const title = useSelector(selectCustomerTitle)

  return (
    <Intro
      customerName={customerName}
      email={email}
      photoUri={photoUri}
      nmls={nmls}
      toName={toName}
      phone={phone}
      title={title}
    >
      <FormattedMessage
        id='HOIntro.salutation.message'
        defaultMessage='Here’s your current home report and tips on how to save money. Call or email with questions!'
      />
    </Intro>
  )
}
